module.exports = __webpack_public_path__ + "media/components/assets/img/bg/footer-bottom-left-flyo-63fb1938d98db6228ec80553bc583b99.svg";